"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarpDrive = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var WarpDrive = (function (_super) {
    __extends(WarpDrive, _super);
    function WarpDrive() {
        return _super.call(this, {
            cost: 14,
            tags: [Tags_1.Tags.SCIENCE],
            name: CardName_1.CardName.WARP_DRIVE,
            cardType: CardType_1.CardType.ACTIVE,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 5); }),
            cardDiscount: { tag: Tags_1.Tags.SPACE, amount: 4 },
            metadata: {
                cardNumber: 'C49',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a Space card, you pay 4 M€ less for it.', function (eb) {
                        eb.space().played.startEffect.megacredits(-4);
                    });
                }),
                description: 'Requires 5 Science tags.',
                victoryPoints: 2,
            },
        }) || this;
    }
    WarpDrive.prototype.getCardDiscount = function (_player, card) {
        if (card.tags.includes(Tags_1.Tags.SPACE)) {
            return 4;
        }
        return 0;
    };
    WarpDrive.prototype.play = function () {
        return undefined;
    };
    WarpDrive.prototype.getVictoryPoints = function () {
        return 2;
    };
    return WarpDrive;
}(Card_1.Card));
exports.WarpDrive = WarpDrive;
//# sourceMappingURL=WarpDrive.js.map